"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = require("@deck.gl/core");

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createForOfIteratorHelper(o) {
  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) {
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var it,
      normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = o[Symbol.iterator]();
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var EVENT_TYPES = ['anyclick', 'pointermove', 'panstart', 'panmove', 'panend', 'keyup'];

var EditableLayer = /*#__PURE__*/function (_CompositeLayer) {
  _inherits(EditableLayer, _CompositeLayer);

  var _super = _createSuper(EditableLayer);

  function EditableLayer() {
    _classCallCheck(this, EditableLayer);

    return _super.apply(this, arguments);
  }

  _createClass(EditableLayer, [{
    key: "onLayerClick",
    // Overridable interaction event handlers
    value: function onLayerClick(event) {// default implementation - do nothing
    }
  }, {
    key: "onStartDragging",
    value: function onStartDragging(event) {// default implementation - do nothing
    }
  }, {
    key: "onStopDragging",
    value: function onStopDragging(event) {// default implementation - do nothing
    }
  }, {
    key: "onDragging",
    value: function onDragging(event) {// default implementation - do nothing
    }
  }, {
    key: "onPointerMove",
    value: function onPointerMove(event) {// default implementation - do nothing
    }
  }, {
    key: "onLayerKeyUp",
    value: function onLayerKeyUp(event) {} // default implementation - do nothing;
    // TODO: implement onCancelDragging (e.g. drag off screen)

  }, {
    key: "initializeState",
    value: function initializeState() {
      this.setState({
        _editableLayerState: {
          // Picked objects at the time the pointer went down
          pointerDownPicks: null,
          // Screen coordinates where the pointer went down
          pointerDownScreenCoords: null,
          // Ground coordinates where the pointer went down
          pointerDownMapCoords: null,
          // Keep track of the mjolnir.js event handler so it can be deregistered
          eventHandler: this._forwardEventToCurrentLayer.bind(this)
        }
      });

      this._addEventHandlers();
    }
  }, {
    key: "finalizeState",
    value: function finalizeState() {
      this._removeEventHandlers();
    }
  }, {
    key: "_addEventHandlers",
    value: function _addEventHandlers() {
      // @ts-ignore
      var eventManager = this.context.deck.eventManager;
      var eventHandler = this.state._editableLayerState.eventHandler;

      var _iterator = _createForOfIteratorHelper(EVENT_TYPES),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var eventType = _step.value;
          eventManager.on(eventType, eventHandler, {
            // give nebula a higher priority so that it can stop propagation to deck.gl's map panning handlers
            priority: 100
          });
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "_removeEventHandlers",
    value: function _removeEventHandlers() {
      // @ts-ignore
      var eventManager = this.context.deck.eventManager;
      var eventHandler = this.state._editableLayerState.eventHandler;

      var _iterator2 = _createForOfIteratorHelper(EVENT_TYPES),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var eventType = _step2.value;
          eventManager.off(eventType, eventHandler);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    } // A new layer instance is created on every render, so forward the event to the current layer
    // This means that the first layer instance will stick around to be the event listener, but will forward the event
    // to the latest layer instance.

  }, {
    key: "_forwardEventToCurrentLayer",
    value: function _forwardEventToCurrentLayer(event) {
      var currentLayer = this.getCurrentLayer(); // Use a naming convention to find the event handling function for this event type

      var func = currentLayer["_on".concat(event.type)].bind(currentLayer);

      if (!func) {
        console.warn("no handler for mjolnir.js event ".concat(event.type)); // eslint-disable-line

        return;
      }

      func(event);
    }
  }, {
    key: "_onanyclick",
    value: function _onanyclick(_ref) {
      var srcEvent = _ref.srcEvent;
      var screenCoords = this.getScreenCoords(srcEvent);
      var mapCoords = this.getMapCoords(screenCoords); // @ts-ignore

      var picks = this.getPicks(screenCoords);
      this.onLayerClick({
        mapCoords: mapCoords,
        // @ts-ignore
        screenCoords: screenCoords,
        picks: picks,
        sourceEvent: srcEvent
      });
    }
  }, {
    key: "_onkeyup",
    value: function _onkeyup(_ref2) {
      var srcEvent = _ref2.srcEvent;
      this.onLayerKeyUp(srcEvent);
    }
  }, {
    key: "_onpanstart",
    value: function _onpanstart(event) {
      var screenCoords = this.getScreenCoords(event.srcEvent);
      var mapCoords = this.getMapCoords(screenCoords); // @ts-ignore

      var picks = this.getPicks(screenCoords);
      this.setState({
        _editableLayerState: _objectSpread({}, this.state._editableLayerState, {
          pointerDownScreenCoords: screenCoords,
          pointerDownMapCoords: mapCoords,
          pointerDownPicks: picks
        })
      });
      this.onStartDragging({
        picks: picks,
        // @ts-ignore
        screenCoords: screenCoords,
        // @ts-ignore
        mapCoords: mapCoords,
        // @ts-ignore
        pointerDownScreenCoords: screenCoords,
        pointerDownMapCoords: mapCoords,
        cancelPan: event.stopImmediatePropagation,
        sourceEvent: event.srcEvent
      });
    }
  }, {
    key: "_onpanmove",
    value: function _onpanmove(event) {
      var srcEvent = event.srcEvent;
      var screenCoords = this.getScreenCoords(srcEvent);
      var mapCoords = this.getMapCoords(screenCoords);
      var _this$state$_editable = this.state._editableLayerState,
          pointerDownPicks = _this$state$_editable.pointerDownPicks,
          pointerDownScreenCoords = _this$state$_editable.pointerDownScreenCoords,
          pointerDownMapCoords = _this$state$_editable.pointerDownMapCoords; // @ts-ignore

      var picks = this.getPicks(screenCoords);
      this.onDragging({
        // @ts-ignore
        screenCoords: screenCoords,
        mapCoords: mapCoords,
        picks: picks,
        pointerDownPicks: pointerDownPicks,
        pointerDownScreenCoords: pointerDownScreenCoords,
        pointerDownMapCoords: pointerDownMapCoords,
        sourceEvent: srcEvent,
        cancelPan: event.stopImmediatePropagation // another (hacky) approach for cancelling map panning
        // const controller = this.context.deck.viewManager.controllers[
        //   Object.keys(this.context.deck.viewManager.controllers)[0]
        // ];
        // controller._state.isDragging = false;

      });
    }
  }, {
    key: "_onpanend",
    value: function _onpanend(_ref3) {
      var srcEvent = _ref3.srcEvent;
      var screenCoords = this.getScreenCoords(srcEvent);
      var mapCoords = this.getMapCoords(screenCoords);
      var _this$state$_editable2 = this.state._editableLayerState,
          pointerDownPicks = _this$state$_editable2.pointerDownPicks,
          pointerDownScreenCoords = _this$state$_editable2.pointerDownScreenCoords,
          pointerDownMapCoords = _this$state$_editable2.pointerDownMapCoords; // @ts-ignore

      var picks = this.getPicks(screenCoords);
      this.onStopDragging({
        picks: picks,
        // @ts-ignore
        screenCoords: screenCoords,
        mapCoords: mapCoords,
        pointerDownPicks: pointerDownPicks,
        pointerDownScreenCoords: pointerDownScreenCoords,
        pointerDownMapCoords: pointerDownMapCoords,
        sourceEvent: srcEvent
      });
      this.setState({
        _editableLayerState: _objectSpread({}, this.state._editableLayerState, {
          pointerDownScreenCoords: null,
          pointerDownMapCoords: null,
          pointerDownPicks: null
        })
      });
    }
  }, {
    key: "_onpointermove",
    value: function _onpointermove(event) {
      var srcEvent = event.srcEvent;
      var screenCoords = this.getScreenCoords(srcEvent);
      var mapCoords = this.getMapCoords(screenCoords);
      var _this$state$_editable3 = this.state._editableLayerState,
          pointerDownPicks = _this$state$_editable3.pointerDownPicks,
          pointerDownScreenCoords = _this$state$_editable3.pointerDownScreenCoords,
          pointerDownMapCoords = _this$state$_editable3.pointerDownMapCoords; // @ts-ignore

      var picks = this.getPicks(screenCoords);
      this.onPointerMove({
        // @ts-ignore
        screenCoords: screenCoords,
        mapCoords: mapCoords,
        picks: picks,
        pointerDownPicks: pointerDownPicks,
        pointerDownScreenCoords: pointerDownScreenCoords,
        pointerDownMapCoords: pointerDownMapCoords,
        sourceEvent: srcEvent
      });
    }
  }, {
    key: "getPicks",
    value: function getPicks(screenCoords) {
      // @ts-ignore
      return this.context.deck.pickMultipleObjects({
        x: screenCoords[0],
        y: screenCoords[1],
        layerIds: [this.props.id],
        radius: this.props.pickingRadius,
        depth: this.props.pickingDepth
      });
    }
  }, {
    key: "getScreenCoords",
    value: function getScreenCoords(pointerEvent) {
      return [pointerEvent.clientX - this.context.gl.canvas.getBoundingClientRect().left, pointerEvent.clientY - this.context.gl.canvas.getBoundingClientRect().top];
    }
  }, {
    key: "getMapCoords",
    value: function getMapCoords(screenCoords) {
      // @ts-ignore
      return this.context.viewport.unproject([screenCoords[0], screenCoords[1]]);
    }
  }]);

  return EditableLayer;
}(_core.CompositeLayer);

exports["default"] = EditableLayer;

_defineProperty(EditableLayer, "layerName", 'EditableLayer');